import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  InputAdornment,
  Grid,
  Tooltip,
  Dialog,
  TextField,
  Container,
  Paper,
  Typography,
  IconButton,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import DateObject from 'react-date-object';
import {
  CANCEL_BUTTON_TEXT,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../../../constants';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../../../services/UserService';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ERROR_KEY } from '../../../../constants';
import { Calendar } from 'react-multi-date-picker';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { applyWfhQuota } from '../../../Services/EmployeePrivilegesService';

const ApplyWfhQuota = (props) => {
  const { toggleOpen, refresh, setRefresh, setLoader } = props;
  const [search, setSearch] = useState(new Map([[0, false]]));
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const [wfhQuotaPayload, setWfhQuotaPayload] = useState([]);
  const dispatch = useDispatch();
  const [openPicker, setOpenPicker] = useState(new Map([[0, false]]));
  const [toSubjects, setToSubjects] = useState([]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  useEffect(() => {
    const newWfhPayloadObject = {
      employeeId: [],
      monthRange: [],
      rangeOption: '',
      wfhQuotaTime: '',
      nameError: false,
      rangeTypeError: false,
      rangeError: false,
      quotaError: false,
      quotaErrorMsg: '',
    };
    setWfhQuotaPayload([newWfhPayloadObject]);
  }, []);

  const checkOptions = (str, index) => {
    const updatedSearch = new Map(search);
    if (str.length > 1) {
      updatedSearch.set(index, true);
    } else {
      updatedSearch.set(index, false);
    }
    setSearch(updatedSearch);
  };

  const handleClickAway = (index) => {
    const updatedSearch = new Map(search);
    updatedSearch.set(index, false);
    setSearch(updatedSearch);
  };

  const handleDeleteEmployee = (employee, index) => {
    const updatedList = wfhQuotaPayload[index].employeeId.filter(
      (emp) => emp.employeeId !== employee.employeeId,
    );
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload[index].employeeId = updatedList;
    setWfhQuotaPayload(updatedWfhPayload);
  };

  const handleEmployeeListChange = (val, index) => {
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload[index].employeeId = val;
    updatedWfhPayload[index].nameError = false;
    setWfhQuotaPayload(updatedWfhPayload);

    const updatedSearch = new Map(search);
    updatedSearch.set(index, false);
    setSearch(updatedSearch);
  };

  const addFeild = () => {
    setSearch(new Map(search.set(wfhQuotaPayload.length, false)));
    const newWfhPayloadObject = {
      employeeId: [],
      monthRange: [],
      rangeOption: '',
      wfhQuotaTime: '',
      nameError: false,
      rangeTypeError: false,
      rangeError: false,
      quotaError: false,
      quotaErrorMsg: '',
    };
    setWfhQuotaPayload([...wfhQuotaPayload, newWfhPayloadObject]);
  };

  const handleRemove = (index) => {
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload.splice(index, 1);
    setWfhQuotaPayload(updatedWfhPayload);
  };

  const handleRangeOptionChange = (event, index) => {
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload[index].monthRange = [];
    updatedWfhPayload[index].rangeOption = event.target.value;
    updatedWfhPayload[index].rangeTypeError = false;
    setWfhQuotaPayload(updatedWfhPayload);
  };

  const handleMonthRangeChange = (props, index) => {
    const updatedWfhPayload = [...wfhQuotaPayload];
    if (wfhQuotaPayload[index].rangeOption === 'Quarterly') {
      const allowedMonths = [1, 4, 7, 10]; // Jan, Apr, Jul, Oct (Months are 1-based in DateObject)

      const isAllowedMonth = (dateObject) =>
        allowedMonths.includes(dateObject.month.number);

      const updatedWfhPayload = [...wfhQuotaPayload];

      // Filter the selected dates
      const filteredDates = props.value.filter(isAllowedMonth);

      if (filteredDates.length === props.value.length) {
        if (wfhQuotaPayload[index].rangeOption === 'Quarterly') {
          if (filteredDates.length === 1) {
            updatedWfhPayload[index].monthRange = [
              filteredDates[0],
              new DateObject(filteredDates[0]).add(2, 'month'),
            ];
            updatedWfhPayload[index].rangeError = false;
          }
        } else if (wfhQuotaPayload[index].rangeOption === 'Monthly') {
          updatedWfhPayload[index].monthRange = [
            filteredDates[filteredDates.length - 1],
          ];
          updatedWfhPayload[index].rangeError = false;
        } else if (wfhQuotaPayload[index].rangeOption === 'Custom') {
          updatedWfhPayload[index].monthRange = filteredDates;
          updatedWfhPayload[index].rangeError = false;
        }
      } else {
        updatedWfhPayload[index].rangeError = true; // Show error if invalid months are selected
      }

      setWfhQuotaPayload(updatedWfhPayload);
      const picker = new Map(openPicker).set(index, false);
      setOpenPicker(picker);
    }
    // if (wfhQuotaPayload[index].rangeOption === 'Monthly') {
    //   updatedWfhPayload[index].monthRange = [
    //     props.value[props.value.length - 1],
    //   ];
    //   updatedWfhPayload[index].rangeError = false;
    //   setWfhQuotaPayload(updatedWfhPayload);
    //   const picker = new Map(openPicker).set(index, false);
    //   setOpenPicker(picker);
    // }
    if (wfhQuotaPayload[index].rangeOption === 'Custom') {
      updatedWfhPayload[index].monthRange = props.value;
      updatedWfhPayload[index].rangeError = false;
      setWfhQuotaPayload(updatedWfhPayload);
      if (props.value.length === 2) {
        const picker = new Map(openPicker).set(index, false);
        setOpenPicker(picker);
      }
    }
  };

  const toggleClosePicker = (index) => {
    const picker = new Map(openPicker).set(index, false);
    setOpenPicker(picker);
  };

  const handleRefershClick = (event, index) => {
    event.stopPropagation();
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload[index].monthRange = [];
    setWfhQuotaPayload(updatedWfhPayload);
  };

  const CreatePayloadforApiCall = () => {
    let payload = [];
    wfhQuotaPayload.forEach((obj) => {
      let newPayloadObject = {
        employeeIds: [],
        monthRange: [],
        wfhQuota: 18,
      };
      newPayloadObject.employeeIds = obj.employeeId.map(
        (emp) => emp.employeeId,
      );

      if (obj.monthRange.length === 1) {
        newPayloadObject.monthRange = [
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
        ];
      } else if (obj.monthRange.length === 2) {
        newPayloadObject.monthRange = [
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
          obj.monthRange[1].year,
          obj.monthRange[1].month.number,
        ];
      }
      newPayloadObject.wfhQuota = obj.wfhQuotaTime;
      payload.push(newPayloadObject);
    });
    return payload;
  };

  const dataValidation = () => {
    const updatedWfhQuotaPaload = wfhQuotaPayload.map((payload) => {
      const updatedname = payload.employeeId.length !== 0;
      const updatedRangeOption = payload.rangeOption.trim() !== '';
      const updatedWfhQuota =
        /^[0-9]+$/.test(payload.wfhQuotaTime) &&
        payload.wfhQuotaTime.trim() !== '';
      const updatedMonthRange = payload.monthRange.length !== 0;
      return {
        ...payload,
        nameError: !updatedname,
        rangeTypeError: !updatedRangeOption,
        rangeError: !updatedMonthRange,
        quotaError: !updatedWfhQuota,
        quotaErrorMsg: !updatedWfhQuota ? '*Enter valid wfh time' : '',
      };
    });

    setWfhQuotaPayload(updatedWfhQuotaPaload);
    const hasError = updatedWfhQuotaPaload.some((payload) => {
      return (
        payload.nameError ||
        payload.rangeError ||
        payload.rangeTypeError ||
        payload.quotaError
      );
    });
    if (hasError) return false;
    return true;
  };

  const handleSubmit = async () => {
    if (dataValidation()) {
      const payload = CreatePayloadforApiCall();
      setLoadingApiCall(true);
      setLoader(true);
      const response = await applyWfhQuota(payload);
      if (response.isError === false) {
        setLoadingApiCall(false);
        toggleOpen();
        setRefresh(!refresh);
      } else {
        setLoadingApiCall(false);
      }
      if (response.status !== 200) {
        dipatchNotification(response.type, response.message);
      }
    }
  };

  const handleWfhQuotaChange = (e, index) => {
    const updatedWfhPayload = [...wfhQuotaPayload];
    updatedWfhPayload[index].wfhQuotaTime = e.target.value;
    updatedWfhPayload[index].quotaError = false;
    updatedWfhPayload[index].quotaErrorMsg = '';
    setWfhQuotaPayload(updatedWfhPayload);
  };

  const loadData = async () => {
    const subjects = await getUsers('');
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Container disableGutters>
      <Paper component={Box} elevation={0} p={5} pt={0}>
        <Grid container>
          <Grid
            container
            className="space-between-container"
            pt={4}
            sx={{
              backgroundColor: 'white',
              position: 'sticky',
              top: 0,
              zIndex: '2',
            }}
          >
            <Grid item>
              <IconButton sx={{ mt: '0px', ml: '-8px' }} onClick={toggleOpen}>
                <KeyboardBackspaceIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton onClick={addFeild}>
                <Typography mr={1}>Add Employee</Typography>
                <AddCircleIcon color="success" />
              </IconButton>
            </Grid>
          </Grid>
          {wfhQuotaPayload.map((payload, index) => (
            <Grid container sx={{ mt: '15px', mb: '20px' }} key={index}>
              <Grid item xs={12} sx={{ mb: '15px' }}>
                <Autocomplete
                  forcePopupIcon={false}
                  multiple
                  disableClearable
                  id={index.toString()}
                  open={search.get(index)}
                  isOptionEqualToValue={(option, value) =>
                    option.employeeId === value.employeeId
                  }
                  options={toSubjects.map((option) => {
                    return {
                      employeeName: option.firstName + ' ' + option.lastName + ' (' + option.employeeCode + ')',
                      employeeId: option.id,
                    };
                  })}
                  getOptionLabel={(option) => option.employeeName}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.employeeId}>
                        {option.employeeName}
                      </li>
                    );
                  }}
                  onInputChange={(e) => checkOptions(e.target.value, index)}
                  value={payload.employeeId}
                  onChange={(e, val) => handleEmployeeListChange(val, index)}
                  filterSelectedOptions
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, id) => (
                      <Chip
                        key={id}
                        label={option.employeeName}
                        onDelete={() => handleDeleteEmployee(option, index)}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={payload.nameError}
                      label="Employee Name / ID"
                      placeholder="Employee Name / ID"
                    />
                  )}
                  sx={{ mt: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={4}>
                    <FormControl size="small" fullWidth>
                      <InputLabel id="month-range-label">Range Type</InputLabel>

                      <Select
                        labelId="month-range-label"
                        label="Range Type"
                        error={payload.rangeTypeError}
                        value={payload.rangeOption}
                        onChange={(event) =>
                          handleRangeOptionChange(event, index)
                        }
                      >
                        {/* <MenuItem value="Monthly">Monthly</MenuItem> */}
                        <MenuItem value="Quarterly">Quarterly</MenuItem>
                        <MenuItem value="Custom">Custom</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sx={{ ml: 2 }}>
                    <TextField
                      name="name"
                      size="small"
                      value={payload.wfhQuotaTime}
                      onChange={(e) => handleWfhQuotaChange(e, index)}
                      id={index.toString()}
                      label="Allot WFH Days Per Quarter"
                      error={payload.quotaError}
                      helperText={payload.quotaErrorMsg}
                    />
                  </Grid>
                  {wfhQuotaPayload.length === 1 ? null : (
                    <Grid item xs={2} sx={{ ml: 4 }}>
                      <Tooltip title="Remove" placement="right">
                        <IconButton onClick={() => handleRemove(index)}>
                          <CloseIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <TextField
                  error={payload.rangeError}
                  //   helperText={error[index].monthError}
                  size="small"
                  value={payload.monthRange.join('-')}
                  disabled={payload.rangeOption === ''}
                  id={index.toString()}
                  onClick={() => {
                    const picker = new Map(openPicker).set(index, true);
                    setOpenPicker(picker);
                  }}
                  label="Month Range"
                  placeholder="Select Month Range"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Referesh">
                          <IconButton
                            onClick={(e) => handleRefershClick(e, index)}
                          >
                            <RestartAltIcon />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
                <Dialog
                  open={openPicker.get(index)}
                  onClose={() => toggleClosePicker(index)}
                  PaperProps={{
                    style: {
                      height: '350px',
                    },
                  }}
                >
                  <Calendar
                    placeholder="  Select Month Range"
                    onlyMonthPicker
                    id={index}
                    range={payload.rangeOption === 'Monthly' ? false : true}
                    value={payload.monthRange}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      height: '38px',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    onPropsChange={(props) => {
                      handleMonthRangeChange(props, index);
                    }}
                  />
                </Dialog>
              </Grid>
            </Grid>
          ))}
          <Grid
            container
            className="space-between-container"
            sx={{ mt: '25px' }}
          >
            <Grid item>
              <Button onClick={toggleOpen} variant="outlined" color={ERROR_KEY}>
                {CANCEL_BUTTON_TEXT}
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                onClick={handleSubmit}
                loading={loadingApiCall}
                variant="contained"
              >
                {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ApplyWfhQuota;
